<!-- nav bar -->
<app-index-navbar class="print:hidden"></app-index-navbar>

<!-- Content -->
<div class="container mx-auto lg:px-0 px-4">
  <router-outlet></router-outlet>
</div>

<!-- Footer -->
<footer class="w-full mt-4 bg-white print:hidden">
  <app-footer class="flex justify-center"></app-footer>
</footer>